import {Api} from './api';
import Poller from './helpers/Poller';
import Uploader from './helpers/Uploader';

const NODE_MAP = {
  contributors: 'contributors',
  creators: 'creators',
  isbns: 'isbns',
  files: 'assets',
  conformances: 'conformances',
};

// DESTROY RECORD actions

function destroyClientRecord(node, nodeId) {
  return {
    type: 'RECORD_DESTROY',
    state: {
      node: node,
      id: nodeId
    }
  }
}

function destroyRecord(projectId, node, nodeId) {
  return function(dispatch) {
    Api.delete(`/api/projects/${projectId}/${NODE_MAP[node]}/${nodeId}`).then(json => {
      dispatch(destroyClientRecord(node, nodeId))
    }).catch( err => {
      dispatch(setState({error: err.message}));
    });
  }
}

export function destroyFile(projectId, nodeId) { return destroyRecord(projectId, 'files', nodeId) }
export function destroyCreator(projectId, nodeId) { return destroyRecord(projectId, 'creators', nodeId) }
export function destroyContributor(projectId, nodeId) { return destroyRecord(projectId, 'contributors', nodeId) }
export function destroyConformance(projectId, nodeId) { return destroyRecord(projectId, 'conformances', nodeId) }
export function destroyIsbn(projectId, nodeId) { return destroyRecord(projectId, 'isbns', nodeId) }

// DESTROY multiple RECORD actions

function destroyClientRecords(node, ids) {
  return {
    type: 'RECORDS_DESTROY',
    state: {
      node: node,
      ids: ids
    }
  }
}

export function destroyFiles(projectId, ids) {
  return function(dispatch) {
    Api.delete(`/api/projects/${projectId}/assets/group`, {assets: ids}).then(json => {
      dispatch(destroyClientRecords('files', ids));
    }).catch( err => {
      dispatch(setState({error: err.message}));
    });
  }
}

// UPDATE_RECORD actions

function updateClientRecord(node, id, attribute, value) {
  return {
    type: 'RECORD_UPDATE',
    state: {
      node: node,
      id: id,
      attribute: attribute,
      value: value
    }
  }
}

function updateRecord(projectId, node, nodeId, attribute, value) {
  return function (dispatch) {
    let obj = {};
    obj[attribute] = value;
    Api.put(`/api/projects/${projectId}/${NODE_MAP[node]}/${nodeId}`, obj).then(json => {
      dispatch(updateClientRecord(node, nodeId, attribute, value))
    }).catch( err => {
      dispatch(setState({error: err.message}));
    });
  }
}

function updateRecordMultiAttributes(projectId, node, nodeId, attributeObject) {
  const mappedAttributes = Object.entries(attributeObject).map(item => ({attribute: item[0], value: item[1], id: nodeId}) );
  return function (dispatch) {
    Api.put(`/api/projects/${projectId}/${NODE_MAP[node]}/${nodeId}`, attributeObject).then(json => {
      dispatch(updateClientRecords(node, mappedAttributes))
    }).catch( err => {
      dispatch(setState({error: err.message}));
    });
  }
}

export function updateFile(projectId, nodeId, attribute, value) {
  return updateRecord(projectId, 'files', nodeId, attribute, value)
}

export function updateIsbn(projectId, nodeId, attribute, value) {
  return updateRecord(projectId, 'isbns', nodeId, attribute, value)
}

//Old version of updateCreator. Likely can be removed without issue.
export function updateCreatorAttribute(projectId, nodeId, attribute, value) {
  return updateRecord(projectId, 'creators', nodeId, attribute, value);
}

export function updateCreator(projectId, nodeId, attributeObject) {
  return updateRecordMultiAttributes(projectId, 'creators', nodeId, attributeObject);
}

//Old version of updateContributor. Likely can be removed without issue.
export function updateContributorAttribute(projectId, nodeId, attribute, value) {
  return updateRecord(projectId, 'contributors', nodeId, attribute, value);
}

export function updateContributor(projectId, nodeId, attributeObject) {
  return updateRecordMultiAttributes(projectId, 'contributors', nodeId, attributeObject);
}

export function updateConformance(projectId, nodeId, attributeObject) {
  return updateRecordMultiAttributes(projectId, 'conformances', nodeId, attributeObject);
}

// RECORD_UPDATES actions

function updateClientRecords(node, updates) {
  return {
    type: 'RECORDS_UPDATE',
    state: {
      node: node,
      updates: updates
    }
  }
}

export function updateFiles(projectId, updates) {
  return function (dispatch) {
    Api.post(`/api/projects/${projectId}/assets/group`, {assets: updates}).then(json => {
      dispatch(updateClientRecords('files', updates))
    }).catch( err => {
      dispatch(setState({error: err.message}));
    });
  }
}

// CREATE_RECORD actions

function createClientRecord(node, attributes) {
  return {
    type: 'RECORD_CREATE',
    state: {
      node: node,
      attributes: attributes
    }
  }
}

function createRecord(projectId, node, attributes) {
  return function (dispatch) {
    Api.post(`/api/projects/${projectId}/${node}`, attributes).then(json => {
      dispatch(createClientRecord(node, json))
    }).catch( err => {
      dispatch(setState({error: err.message}));
    });
  }
}

export function createCreator(projectId, attributes) { return createRecord(projectId, 'creators', attributes) }
export function createContributor(projectId, attributes) { return createRecord(projectId, 'contributors', attributes) }
export function createConformance(projectId, attributes) { return createRecord(projectId, 'conformances', attributes) }
export function createIsbn(projectId, attributes) { return createRecord(projectId, 'isbns', attributes) }

// CREATE FILES actions

function createClientFiles(files) {
  return {
    type: 'FILES_CREATE',
    state: {
      files: files,
    }
  }
}

function setLoading(loading, message = '') {
  return {
    type: 'SET_LOADING',
    state: {
      loading: loading,
      message: message
    }
  }
}

export function createFiles(projectId, files, cover, globalImageSettings) {
  return function (dispatch) {
    dispatch(setLoading(true, 'Files are uploading.'));

    let uploader = new Uploader(
      files,
      cover,
      projectId,

      (percent) => {
        dispatch(setState({percentDone: percent}));
      },

      () => {
        dispatch(setLoading(false));
        window.location = `/wfdw/projects/${projectId}`;
      },

      (err) => {
        dispatch(setState({loading: false, error: err.message}));
      },
      globalImageSettings
    );
    uploader.uploadFiles();
  }
}

export function addOrgAssets(projectId, fileIds) {
  return function (dispatch) {
    return Api.put(`/api/projects/${projectId}/assets/org`, {assets: fileIds}).then(json => {
      dispatch(getState(projectId));
    }).catch( err => {
      dispatch(setState({error: err.message}));
    });
  }
}

// UPDATE SETTINGS actions

function updateClientSettings(settingValues) {
  return {
    type: 'SETTINGS_UPDATE',
    state: settingValues
  }
}

export function updateSettings(projectId, settingValues) {
  return function (dispatch) {
    Api.put(`/api/projects/${projectId}`, {settings: settingValues}).then(json => {
      dispatch(updateClientSettings(settingValues))
    }).catch( err => {
      dispatch(setState({error: err.message}));
    });
  }
}

export function updateSubjects(subjects) {
  return {
    type: 'SUBJECTS_UPDATE',
    state: {subjects: subjects}
  }
}

// UPDATE PROJECT actions

function updateClientProject(attribute, value) {
  return {
    type: 'PROJECT_UPDATE',
    state: {
      attribute: attribute,
      value: value
    }
  }
}

export function updateProject(projectId, attribute, value) {
  return function (dispatch) {
    let obj = {};
    obj[attribute] = value;
    Api.put(`/api/projects/${projectId}`, obj).then(json => {
      dispatch(updateClientProject(attribute, value))
    }).catch( err => {
      dispatch(setState({error: err.message}));
    });
  }
}

export function setStatistics(filename, statistics) {
  return {
    type: 'SET_STATISTICS',
    state: {
      filename: filename,
      statistics: statistics
    }
  }
}

// RUN CONVERSION actions

export function setState(json) {
  return {
    type: 'SET_STATE',
    state: json
  }
}

function getState(projectId) {
  return function(dispatch) {
    Api.get(`/api/projects/${projectId}`).then(json => {
      json['loading'] = false;
      dispatch(setState(json));
    }).catch( err => {
      dispatch(setState({error: err.message}));
    });
  }
}

export function clearError() {
  return function(dispatch) {
    dispatch(setState({error: null}));
  }
}

export function pollStatus(projectId) {
  return function(dispatch) {
    let poll = new Poller(
      () => {
        return Api.get(`/api/projects/${projectId}/status`);
      },

      (json) => {
        return json['status'] === 'ok';
      },

      () => {
        dispatch(getState(projectId));
      },

      2000
    );

    poll.poll();
  }
}

export function performConversion(projectId, conv) {
  return function(dispatch) {
    dispatch(setLoading(true, 'Conversion in Progress'));
    Api.put(`/api/projects/${projectId}/conversion/${conv}`).then(json => {
      let poll = new Poller(
        () => {
          return Api.get(`/api/projects/${projectId}/status`);
        },

        (json) => {
          return json['status'] === 'ok';
        },

        () => {
          dispatch(getState(projectId));
        },

        2000
      );

      poll.poll();
    }).catch( err => {
      dispatch(setState({loading: false, error: err.message}));
    });
  }
}

export function makeSample(projectId, conv, config) {
  return function(dispatch) {
    dispatch(setLoading(true, 'Conversion in Progress'));
    Api.post(`/api/projects/${projectId}/sample/${conv}`, {config: config}).then(json => {
      let poll = new Poller(
        () => {
          return Api.get(`/api/projects/${projectId}/status`);
        },

        (json) => {
          return json['status'] === 'ok';
        },

        () => {
          // needs to fetch zip
          dispatch(getState(projectId));
        },

        2000
      );

      poll.poll();
    }).catch( err => {
      dispatch(setState({loading: false, error: err.message}));
    });
  }
}

// GET STATISTICS

export function getStatistics(fileId) {
  return function(dispatch) {
    Api.get(`/api/assets/statistics/${fileId}`).then(json => {
      dispatch(updateClientRecord('files', fileId, 'statistics', json));
      dispatch(setState({
        statistics: json
      }));
    }).catch( err => {
      dispatch(setState({error: err.message}));
    });
  }
}

export function getGroupStatistics(projectId, fileGroup) {
  return function(dispatch) {
    Api.get(`/api/projects/statistics/${projectId}/${fileGroup}`).then(json => {
      dispatch(setState({
        statistics: json
      }));
    }).catch( err => {
      dispatch(setState({error: err.message}));
    });
  }
}

export function getChecks(fileId) {
  return function(dispatch) {
    Api.get(`/api/assets/checks/${fileId}`).then(json => {
      dispatch(updateClientRecord('files', fileId, 'checks', json));
      dispatch(setState({
        checks: json
      }));
    }).catch( err => {
      dispatch(setState({error: err.message}));
    });
  }
}

// CREATE Project

export function createProject(projectData, redirect = false) {
  return function(dispatch) {
    Api.post("/api/projects", projectData).then(json => {
      if(redirect) {
        window.location = `/wfdw/projects/${json.id}`;
      } else {
        dispatch(setState(json));
      }
    }).catch( err => {
      dispatch(setState({error: err.message}));
    });
  }
}

// GET SubjectData

export function setSubjectData() {
  return function(dispatch) {
    Api.get('/api/subjects').then(json => {
      dispatch(setState({subjectData: json}));
    }).catch( err => {
      dispatch(setState({error: err.message}));
    });
  }
}

// GET Users

export function setUsers() {
  return function(dispatch) {
    Api.get('/users').then(json => {
      dispatch(setState({users: json}));
    }).catch( err => {
      dispatch(setState({error: err.message}));
    });
  }
}
